/* unplugin-vue-components disabled */import { render } from "./ArchiveList.vue?vue&type=template&id=44cf7b4e&scoped=true"
import script from "./ArchiveList.vue?vue&type=script&lang=js"
export * from "./ArchiveList.vue?vue&type=script&lang=js"

import "./ArchiveList.vue?vue&type=style&index=0&id=44cf7b4e&lang=less&scoped=true"

import exportComponent from "/Users/zhaoxu/Documents/development.localized/public.localized/github/KilaKila-Blog/kilakila-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44cf7b4e"]])

export default __exports__